import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getMostRecentLocations } from '@rsos/utils/getMostRecentLoc';

/**
 * Returns the center point of the polygon for the current geofence.
 */
const useCenterPoint = () => {
  const { exact_polygon_center, expanded_polygon_center } = useSelector(
    state => state.geofences.currentGeofence,
  );
  const polygonCenter = useMemo(() => {
    if (
      exact_polygon_center &&
      exact_polygon_center?.length &&
      exact_polygon_center?.length === 2 &&
      exact_polygon_center[0] !== 0 &&
      exact_polygon_center[1] !== 0
    ) {
      return exact_polygon_center;
    } else {
      return expanded_polygon_center; // expanded_polygon_center is always there.
    }
  }, [exact_polygon_center, expanded_polygon_center]);
  const { selectedAlertID, alerts } = useSelector(state => state.incidents);
  const alertLocation = alerts[selectedAlertID]?.location?.geodetic;

  const selectedCallerID = useSelector(
    state => state.emergencyCalls.selectedCallerID,
  );
  const callQueue = useSelector(state => state.emergencyCalls.callQueue);
  const { mostRecentLocation, mostRecentSecondaryLocation } =
    getMostRecentLocations(callQueue[selectedCallerID]);

  const latitude = polygonCenter?.[1] || 0;
  const longitude = polygonCenter?.[0] || 0;
  const memoedLocation = useMemo(() => {
    if (selectedCallerID && mostRecentLocation) {
      return {
        latitude: mostRecentLocation.latitude,
        longitude: mostRecentLocation.longitude,
      };
    } else if (selectedCallerID && mostRecentSecondaryLocation) {
      return {
        latitude: mostRecentSecondaryLocation.latitude,
        longitude: mostRecentSecondaryLocation.longitude,
      };
    } else if (selectedAlertID && alertLocation) {
      return {
        latitude: alertLocation.latitude,
        longitude: alertLocation.longitude,
      };
    } else {
      return { latitude, longitude };
    }
  }, [
    latitude,
    longitude,
    mostRecentLocation,
    mostRecentSecondaryLocation,
    selectedCallerID,
    selectedAlertID,
    alertLocation,
  ]);
  return memoedLocation;
};

export default useCenterPoint;
